const ContactHours = ({
  sunday = '',
  monday = '',
  tuesday = '',
  wednesday = '',
  thursday = '',
  friday = '',
  saturday = '',
} = {}) => ({
  sunday: String(sunday),
  monday: String(monday),
  tuesday: String(tuesday),
  wednesday: String(wednesday),
  thursday: String(thursday),
  friday: String(friday),
  saturday: String(saturday),
});

export default ContactHours;

export type ContactHoursProps = ReturnType<typeof ContactHours>;
